class Networking {
    // ============
    // Set base url
    // ============
    constructor() {
      this.base_url = 'http://localhost:8000/';
      this.base_url = 'https://bbtemp.reoncloud.com/server/';
      this.base_url = 'https://kerfi.bunadarbanki.is/server/';
    }

    // =============
    // HTTP requests
    // =============
    GET(url, success, failure) {
        $.ajax({
            "type": "GET",
            "url": this.base_url+url,
            "headers": {
                "Authorization": "Token "+localStorage.getItem("token")
            },
            "contentType": "application/json",
            "success": success,
            "error": failure
        });
    };

    POST(url, data, success, failure) {
        var headers = {
            "Authorization": "Token "+localStorage.getItem("token")
        }
        if (url === "api-token-auth/" || url === "selfsignup/") {
            headers = {};
        }
        $.ajax({
            "type": "POST",
            "url": this.base_url+url,
            "headers": headers,
            "contentType": "application/json",
            "dataType": "json",
            "data": JSON.stringify(data),
            "success": success,
            "error": failure
        });
    };

    PUT(url, data, success, failure) {
        $.ajax({
            "type": "PUT",
            "url": this.base_url+url,
            "headers": {
                "Authorization": "Token "+localStorage.getItem("token")
            },
            "contentType": "application/json",
            "dataType": "json",
            "data": JSON.stringify(data),
            "success": success,
            "error": failure
        });
    };

    DELETE(url, success, failure) {
        $.ajax({
            "type": "DELETE",
            "url": this.base_url+url,
            "headers": {
                "Authorization": "Token "+localStorage.getItem("token")
            },
            "success": success,
            "error": failure
        });
    };

    IMPORT(data, success, failure) {
        $.ajax({
            url: this.base_url+"excel/",
            headers: {
                Authorization: "Token "+localStorage.getItem("token")
            },
            type: 'PUT',
            data: data,
            async: false,
            success: success,
            error: failure,
            cache: false,
            contentType: false,
            processData: false
        });
    }
}

module.exports = Networking;



// WEBPACK FOOTER //
// ./app/scripts/utils/Networking.js